import PropTypes from "prop-types";
import Link from "next/link";
import Title from "components/shared/stays/Title";
import Photo from "components/shared/stays/Photo";
import styles from "components/destination/RegionListItem.module.scss";

export default function RegionListItem({ name, mainImage, url }) {
  return (
    <Link prefetch={false} className={styles.component} href={url}>
      <div className={styles.image}>
        <Photo src={mainImage} alt={name} layout="fill" objectFit="cover" />
      </div>
      <div className={styles.text}>
        <Title tag="h3" size={5}>
          {name}
        </Title>
      </div>
    </Link>
  );
}

RegionListItem.propTypes = {
  name: PropTypes.string.isRequired,
  mainImage: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
